import { modifier } from 'ember-modifier';
const modalContainerId = 'fly-modals';
const tooltipsContainerId = 'fly-tooltips';
export default modifier(function didClickOutside(element, [callback]) {
  // If this modifier gets set up while the user is already pressing down the mouse
  // button, it will fire as soon as the user releases it.
  // (https://github.com/customerio/fly-components/pull/601#discussion_r1046556873)
  // This event prevents this behavior, tracking only clicks that are _initiated after_
  // this modifier has been set up.
  document.addEventListener('mousedown', handleMouseDown);
  let hasStartedClickAfterSetup = false;
  function handleMouseDown() {
    hasStartedClickAfterSetup = true;
  }
  function close(event) {
    if (!hasStartedClickAfterSetup || !element || !event.target || !(event.target instanceof Node)) {
      return;
    }
    let inComponent = element.isSameNode(event.target) || element.contains(event.target);
    let tooltips = document.getElementById(tooltipsContainerId);
    let inTooltip = tooltips?.contains(event.target);
    let modals = document.getElementById(modalContainerId);
    let inModal = modals?.contains(event.target);
    let modalContainsDropdown = modals?.contains(element);
    if (inComponent || inTooltip || inModal && !modalContainsDropdown) {
      return;
    }
    callback();
    return false;
  }
  document.addEventListener('click', close);
  return () => {
    document.removeEventListener('click', close);
    document.removeEventListener('mousedown', handleMouseDown);
  };
});